import React, {createContext, useReducer} from 'react';
import {initState} from "./initState";
import {getLocalStorage, setLocalStorage, setLocalStorageNode} from "../services/local_storage";
import userProfileReducer from "../reducers/reducers"
import {
    USER_STATE_SAVE,
    LOAD_USER
} from "../actions";

export const GlobalContext = createContext({
    ...initState,
    loadUser: () => {},
    saveLocalState: () => {}
})

const GlobalState = (props) => {
    const [userState, dispatch] = useReducer(userProfileReducer, {...initState});

    const loadUser = async () => {
        let local = await getLocalStorage();
        if(initState.version !== local?.version)
            local = initState;
        const state = await setLocalStorage({
            ...initState,
            ...local,
        });
        dispatch({
            type: LOAD_USER,
            ...state
        });
        return state.user;
    }
    const saveLocalState = async (node, data) => {
        const localState = await setLocalStorageNode(node, data);

        if (localState)
            dispatch({type: USER_STATE_SAVE, node, data})
    };

    return (
        <GlobalContext.Provider
            value={{
                ...userState,
                loadUser,
                saveLocalState,
            }}>
            {props.children}
        </GlobalContext.Provider>
    );

}

export default GlobalState;
